import { httpClient } from "./httpClient";
import { MenuHeader } from "@/types/menu";

interface IMenuService {
  getMenuHeaders(): Promise<MenuHeader[]>;
}

class MenuService implements IMenuService {
  private readonly basePath = "/api/v1/catalogos/menus";

  public async getMenuHeaders(): Promise<MenuHeader[]> {
    return await httpClient.get<MenuHeader[]>(this.basePath);
  }
}

export const menuService = new MenuService();
